import React from 'react';
import { PieChart, Pie as RechartsPie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import '../../ExpensesAnalyticsWidget.css';

const RADIAN = Math.PI / 180;

// פונקציית עזר לציור הקווים והטקסט (Spider Labels)
const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index, name, value, payload }) => {
  if (!cx || !cy || !payload) return null;

  const color = payload.color;
  const sin = Math.sin(-midAngle * RADIAN);
  const cos = Math.cos(-midAngle * RADIAN);
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;
  const mx = cx + (outerRadius + 30) * cos;
  const my = cy + (outerRadius + 30) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 22;
  const ey = my;
  const textAnchor = cos >= 0 ? 'start' : 'end';

  return (
    <g>
      {/* הקו המחבר */}
      <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={color} fill="none" strokeWidth="2" />

      {/* עיגול קטן בקצה */}
      <circle cx={ex} cy={ey} r={2} fill={color} stroke="none" />

      {/* הטקסט (שם הקטגוריה) */}
      <text
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey}
        textAnchor={textAnchor}
        fill="#3E2723"
        fontSize="14"
        fontWeight="bold"
        dominantBaseline="central"
      >
        {name}
      </text>

      {/* הסכום מתחת לשם */}
      <text
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey}
        dy={18}
        textAnchor={textAnchor}
        fill="#3E2723"
        fontSize="16"
        fontWeight="bold"
        dominantBaseline="central"
      >
        {`₪${value.toLocaleString()}`}
      </text>
    </g>
  );
};

const Pie = ({ data = { categories: [] }, freeText = '', EXPENSES_ANALYTICS_WIDTH, EXPENSES_ANALYTICS_HEIGHT, title = 'פילוח הוצאות', showTitle = true }) => {
  const total = data.categories.reduce((sum, cat) => sum + cat.amount, 0);

  return (
    <div
      style={{
        width: `${EXPENSES_ANALYTICS_WIDTH}px`,
        height: `${EXPENSES_ANALYTICS_HEIGHT}px`,
        display: 'flex',
        flexDirection: 'column',
        direction: 'rtl',
        padding: '20px',
        paddingBottom: '30px',
        overflow: 'hidden',
        boxSizing: 'border-box'
      }}
    >
      {/* Header */}
      {showTitle && (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderBottom: '1px solid #D7CCC8',
          paddingBottom: '10px',
          marginBottom: '5px',
          zIndex: 10
        }}>
          <h2 style={{
            margin: 0,
            fontSize: '22px',
            color: '#3E2723',
            fontWeight: 'bold'
          }}>{title}</h2>

          <div style={{
            fontSize: '16px',
            color: '#B71C1C',
            fontWeight: 'bold',
            backgroundColor: '#FFEBEE',
            padding: '2px 8px',
            borderRadius: '4px',
            border: '1px solid #FFCDD2'
          }}>
            סה"כ: ₪{total.toLocaleString()}
          </div>
        </div>
      )}

      {/* אזור הגרף */}
      <div style={{ flex: 1, width: '100%', position: 'relative', direction: 'ltr' }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <RechartsPie
              data={data.categories}
              cx="50%"
              cy="50%"
              labelLine={false}
              label={renderCustomizedLabel}
              outerRadius={65}
              innerRadius={38}
              fill="#8884d8"
              dataKey="amount"
              paddingAngle={2}
              isAnimationActive={false}
            >
              {data.categories.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} stroke="#FDFBF7" strokeWidth={2} />
              ))}
            </RechartsPie>
            {/* Tooltip בעיצוב מותאם */}
            <Tooltip
              contentStyle={{
                backgroundColor: '#FFF8E1',
                border: '1px solid #D7CCC8',
                borderRadius: '4px',
                color: '#3E2723'
              }}
              formatter={(value) => `₪${value.toLocaleString()}`}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>

      {/* Free text at the bottom */}
      {freeText && (
        <div style={{
          textAlign: 'center',
          fontSize: '18px',
          color: '#3E2723',
          fontWeight: 'bold',
          marginTop: '25px',
          whiteSpace: 'pre-wrap',
          lineHeight: '1.4'
        }}>
          {freeText}
        </div>
      )}
    </div>
  );
};

export default Pie;